module.exports = __webpack_public_path__ + "media/images/icons/country_flags/io-a5cb8dd8c8d6ec789e1f87e75d3d76cb.svg";